import React from "react"

type Props = {
    style?: any
}

export default function Modal_CheckingUsers(props: Props) {

    const style = props.style || {height: 'calc(100% - 100px)'}

    return (
        <div className="flex-row-center-center" style={style}>
            <div className="ui5-txt-not-important-small">
                Checking users...
            </div>
        </div>
    )
}